<script>
    // export let text = 'CTA';
    export let text;
    export let rounded = "0em";
    export let transparent = false;
    export let color = "white";
    export let background = "#4FC3A1";
    export let backgroundHover = "#47b192";
    export let w = "100%";
    export let h = "3em";
    export let margin = "0em";
    export let weight = 600;
    export let border = "none";



</script>


        <div class="button" value="{text}" class:transparent on:click style="--background:{background};--color:{color};--backgroundHover:{backgroundHover};--rounded:{rounded};--width:{w};--height:{h};--margin:{margin};--weight:{weight};--border:{border};padding:0 2em"  >
            {#if text}
                {text}
            {:else}
                <slot></slot>
            {/if}
        </div>

<style>

 .button {
      /* min-width: 64px; */
      line-height: var(--height);
      width:var(--width);
      height:var(--height);
      margin: var(--margin);
      /* line-height:1em; */
      text-align:center;
      border: none;
      background: var(--background);
      text-decoration: none;
      color: var(--color);
      cursor: pointer;
      outline: none;
      position: relative;
      overflow: hidden;
      font-size: 1em;
      /* font-weight: 700; */
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      display: inline-block;
      transition: background 0.2s;    
      border-radius: var(--rounded);
      border: var(--border);
      font-weight: var(--weight);
    }

    .button.transparent{
        background:transparent;
        color:black;
    }

    .button.button.transparent:hover{
        background-color: var(--backgroundHover);
        /* background-color: rgba(222,222,222,0.5); */
    }
	
    .button:hover{
        background-color:  var(--backgroundHover);
    }

    
	 /* .button:active{
        background-color: #4FC3A1;
    } */

</style>